import { UnauthRoute, AuthRoute } from 'react-router-auth';
function encodeQueryData(data) {
   const ret = [];
   for (let d in data)
     ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
   return ret.join('&');
}
const routes = {
  login: '/',
  orderCustomerSelection: '/orderCreation',
  productList: '/productList',
  productDetail: (({ name, tischOffensiveId, color }) => {
    let args = {};
    if (tischOffensiveId) {
      args.tischOffensiveId = tischOffensiveId;
    }
    if (color) {
      args.color = color;
    }

    if (Object.keys(args).length>0) {
      return `/productDetail/${name}?${encodeQueryData(args)}`;
    }

    return `/productDetail/${name}`;
  }),

  productDetailWithColor: ({ name, color }) => `/productDetail/${name}?color=${color}`,
  orderList: '/orderList',
  currentOrder: '/currentOrder',
  orderUpdate: (id) => `/orderUpdate/${id}`,
  landingPage: '/home',
  orderConfirmation: '/orderConfirmation',
  lowaCustomerSelect: '/lowaSelect',
};

export const firstScreen = routes.landingPage;
export const lowaCustomerSelect = routes.lowaCustomerSelect;

const AuthorizedRoute = AuthRoute;
const UnauthorizedRoute = UnauthRoute;

export { AuthorizedRoute, UnauthorizedRoute, routes };
